import Vue from "vue";
import ListView from "../../../common/models/listViews/listView";
import BaseObjectModelEntry from "../../../common/models/objectModelEntries/baseObjectModelEntry";
import contentElementBaseMixin from "../../../common/mixins/listViews/contentElementBaseMixin";
import ViewLinkable from "../components/list-view-content-element-view-linkable.vue"
import BlankFallback from "../components/content-view-blank-fallback.vue"
import PublishedListView from "../../../common/models/listViews/publishedListView";

export default Vue.extend({
  components: {
    ViewLinkable,
    BlankFallback,
  },
  mixins: [
    contentElementBaseMixin,
  ],
  props: {
    listView: {
      type: Object as () => ListView | PublishedListView,
      required: true,
    },
    entry: {
      type: Object as () => BaseObjectModelEntry,
      required: true,
    },
    isInDetailViewEditMode:{
      type: Boolean,
      default: false
    },
  },
});